import { makeAbout } from 'src/main/factories/pages'

export default makeAbout
